import { IBookingDeposit } from "api/rpc/2024-04/facilityAdmin/deposit/deposit";
import { ButtonNew as Button } from "components/buttonNew";
import DataTable from "components/dataTable/DataTable";
import Input from "components/form/input";
import Sheet from "components/sheet/Sheet";
import Portal from "elements/Portal";
import { LocaleCurrency } from "helpers/Locale";
import useCurrencyFacility from "hooks/useCurrency/useCurrencyFacility";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    open: boolean;
    deposits: Array<IBookingDeposit>;
    onOk: (deposit: IBookingDeposit) => void;
    onCancel: () => void;
}

export default function BookingDepositsModal(props: IProps) {
    const { open, deposits, onCancel, onOk } = props;
    const { t } = useTranslation();
    const { getCurrencySymbol } = useCurrencyFacility();
    const [bookingDeposits, setBookingDeposits] = useState<Array<IBookingDeposit & {amountToApply?: string; full_name?: string}>>([]);

    useEffect(() => {
        if (deposits && open) {
          const updatedDeposits = deposits?.map(deposit => ({...deposit, amountToApply: deposit?.amount_remaining?.toString()}));
          setBookingDeposits(updatedDeposits);
        }
      }, [deposits, open]);

      function handleDepositAmountChange(e: React.ChangeEvent<HTMLInputElement>, deposit: IBookingDeposit) {
        const {value} = e.target;
        if (Number(value) > deposit?.amount_remaining) {
          return;
        }
        setBookingDeposits(prev => prev?.map(prevDeposit => prevDeposit?.id === deposit?.id ? {...prevDeposit, amountToApply: value} : prevDeposit));
      }

    return (
        <Portal isMounted={open}>
            <Sheet
            title={t("Booking Deposits")}
            open={open}
            size="small"
            onCancel={onCancel}
            cancelText={t("Close")}
            closable
            backDropCancel={false}
            >
            <DataTable columns={[{label: t("Depositor")}, { label: t("Remaining")}, {label: t("Apply Amount")}, {label: ""}]} loading={deposits === undefined}>
                {bookingDeposits?.map((deposit, index) => {
                    return (
                        <tr key={index}>
                            <td>{deposit?.full_name}</td>
                            <td><LocaleCurrency amount={deposit?.amount_remaining} currency={deposit?.currency ?? "CAD"} /></td>
                            <td><Input labelHidden placeholder={"0.00"} error={Number(deposit?.amountToApply) <= 0 || Number(deposit?.amountToApply) > deposit?.amount_remaining} type="number" value={deposit?.amountToApply} prefix={getCurrencySymbol(deposit?.currency) ?? "$"} onChange={e => handleDepositAmountChange(e, deposit)} /></td>
                            <td><Button onClick={() => onOk(deposit)} type="text" size="medium" disabled={Number(deposit?.amountToApply) <= 0 || Number(deposit?.amountToApply) > deposit?.amount_remaining}>{t("Apply")}</Button></td>
                        </tr>
                    );
                })}
            </DataTable>

            </Sheet>
        </Portal>
    );
}